import React,{ Component } from "react"
import {
  NavBar,
  Icon,
  List,
  SearchBar,
  WhiteSpace,
  WingBlank,
  Toast,
  Pagination
} from 'antd-mobile'
import "./ipvinfo.scss"
import axios from "../../service/axios"
import NoneDatas from "../../components/noneDatas"
import Search from "../../components/search/search"

const Item = List.Item
const Brief = Item.Brief

export class IpvInfo extends Component {
  state = {
    ipvData: [],
    pageTotalNum: 0,
    pageNo:1
  }
  componentDidMount(){
    console.log('ipvInfo',this.props)
    this.getIpvList(
      sessionStorage.getItem("ipvListPage")
        ? sessionStorage.getItem("ipvListPage")
        : 1,
    )
  }
  // 获取列表数据
  getIpvList(e){
    Toast.loading('加载中...', 0)
    axios.post("/wapi/dev/ipv/list",{
      page: {
        pageSize: 10,
        pageNo: e
      },
    }).then( res => {
      console.log('??',res)
      if(res && res.status == 200){
        let arr = []
        
        this.setState({
          ipvData: res.data.resultList,
        })
      } else {
        console.log('err',res)
        Toast.fail("获取列表失败，请稍后再试")
      }
    })
  }
  // 跳转指定页
  onPageChange(e) {
    e = e > this.state.pageTotalNum ? this.state.pageTotalNum : e
    this.getIpvList(e);
    sessionStorage.setItem("ipvListPage", e);
  }
  render(){
    const { 
      ipvData,
      pageTotalNum,
      pageNo,
    } = this.state
    const ItemList = ({item}) => (
      <div>
        {item.devName} (
          {item.online == 2 ?(<span style={{color: "#0078D7"}}>在线 </span>):(<span>离线 </span>)}
        )
        <Brief>
          <span>
            设备编号 : 
            {item.devId}{" "}
          </span>
          &ensp;&ensp;
          <span>
            账号 :
            {item.account}
          </span>{" "}
        </Brief>
        <Brief>
          <span>
            创建时间 :
            {item.createDate}
          </span>{" "}
          <span>
            所在群组 :
            {item.gname}
          </span>
        </Brief>
      </div>
    )
    return (
      <div>
        <div className="header-sticky">
          <NavBar
            icon={<Icon type="left" />}
            onLeftClick={() => this.props.history.goBack()}
          >
            音柱列表
          </NavBar>
        </div>
        <div className="sub-container">
          <WhiteSpace />
          {ipvData.map((item,index) => {
            return (
              <Item
                // arrow="horizontal"
                multipleLine
                key={index}
              >
                <ItemList item={item}/>
              </Item>
            )
          })}
          {ipvData.length == 0 ? <NoneDatas />:''}
          <WhiteSpace />
          <WingBlank>
          {pageTotalNum > 0 ? (
            <SearchBar
              placeholder="请输入跳转页面"
              onSubmit={value => this.onPageChange(value)}
            />
          ) : ''}
          </WingBlank>
          <WhiteSpace />
          <WingBlank>
            {pageTotalNum > 0 ? (
              <Pagination
                total={pageTotalNum}
                current={pageNo}
                locale={{
                  prevText: "上一页",
                  nextText: "下一页",
                }}
                onChange={e => this.onPageChange(e)}
              />
            ) : (
                ""
              )}
          </WingBlank>
        </div>

      </div>
    )
  }
}

export default IpvInfo
